export default "__VITE_ASSET__C$rezGkV__"